// extracted by mini-css-extract-plugin
export default {"container":"ChargePointDetailsTabsSkeleton_container__jj0v9","tab":"ChargePointDetailsTabsSkeleton_tab__s1YYt","text":"ChargePointDetailsTabsSkeleton_text__q24gN"};